/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Addsecondaryemail2Inputs */

const en_settings_addsecondaryemail2 = /** @type {(inputs: Settings_Addsecondaryemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add secondary email`)
};

/**
* | output |
* | --- |
* | "Add secondary email" |
*
* @param {Settings_Addsecondaryemail2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_addsecondaryemail2 = /** @type {((inputs?: Settings_Addsecondaryemail2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Addsecondaryemail2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_addsecondaryemail2(inputs)
});
export { settings_addsecondaryemail2 as "settings_addSecondaryEmail" }